module.exports = __webpack_public_path__ + "static/media/Blade_U-HookArm.340f694e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/wiper-blades-adapters/Blade_U-HookArm.jpg
// module id = 144
// module chunks = 0